import type { TestimonialDTO } from '../types/landing.types';

const delay = (ms: number) => new Promise(res => setTimeout(res, ms));

export const fetchAllTestimonials = async (): Promise<TestimonialDTO[]> => {
	await delay(400);
	return [];
};

export const fetchTestimonialById = async (id: string): Promise<TestimonialDTO | null> => {
	await delay(300);
	void id;
	return null;
};

export const createTestimonial = async (data: FormData): Promise<TestimonialDTO> => {
	await delay(400);
	return {
		_id: String(Date.now()),
		name: (data.get('name') as string) ?? '',
		occupation: (data.get('occupation') as string) ?? '',
		testimonial: (data.get('testimonial') as string) ?? '',
		status: data.get('status') === 'yes',
	};
};

export const updateTestimonial = async (id: string, data: FormData): Promise<TestimonialDTO> => {
	await delay(400);
	return {
		_id: id,
		name: (data.get('name') as string) ?? '',
		occupation: (data.get('occupation') as string) ?? '',
		testimonial: (data.get('testimonial') as string) ?? '',
		status: data.get('status') === 'yes',
	};
};

export const deleteTestimonialAvatar = async (id: string): Promise<void> => {
	await delay(300);
	void id;
};

export const deleteTestimonial = async (id: string): Promise<void> => {
	await delay(300);
	void id;
};
